import React from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import { ClassesSection } from '../component/ClassesSection';
import { useAuth } from '../context/AuthContext';

const LiveClasses = () => {
  const { isAdmin } = useAuth();

  return (
    <>
      <Header />
      <main className="min-h-screen bg-[#fcfaf8] px-6 pb-16 pt-28 font-sans text-zinc-900">
        <div className="mx-auto max-w-7xl">
          <div className="mb-10">
            <p className="text-xs font-black uppercase tracking-widest text-amber-600">Admin</p>
            <h1 className="mt-2 text-4xl font-black tracking-tight text-zinc-900">Live Classes</h1>
            <p className="mt-2 text-zinc-500">Create and manage upcoming and past live classes.</p>
          </div>
          <ClassesSection token={localStorage.getItem('token')} isAdmin={isAdmin} />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default LiveClasses;
